import React from 'react';
import { useStyles } from './CalendarListItem.style';
import { Skeleton } from '@mui/material';
import { VERTICAL_SEPARATOR } from '~/Constants/Colors.constants';

interface CalendarListItemSkeletonProps {
  repetitions?: number;
}

export const CalendarListItemSkeleton = ({ repetitions = 2 }: CalendarListItemSkeletonProps) => {
  const { classes } = useStyles({
    color: VERTICAL_SEPARATOR,
    hasBreak: false,
    isCancelled: false,
  })();

  return (
    <div data-testid="calendarlistitem-skeleton">
      {Array.from(Array(repetitions).keys()).map((index) => (
        <div className={classes.eventItem} key={`skeleton_${index}`}>
          <div className={classes.eventTimeWrapper}>
            <Skeleton variant="rounded" height={10} width={35} />
            <Skeleton variant="rounded" height={10} width={35} />
          </div>
          <div className={classes.eventInfoWrapper}>
            <div className={classes.eventNameWrapper}>
              <span className={`${classes.eventNameText} ${classes.spacingBottom}`}>
                <Skeleton variant="rounded" height={10} width={130} style={{ marginBottom: 8 }} />
              </span>
              <span className={classes.eventInfoTextWrapper}>
                <Skeleton variant="rounded" height={10} width={130} />
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
